<template>
    <div>
        <v-row class="white pl-3 pr-3 ml-0 mr-0">
            <v-col  md="4" sm="6" xs="12">
                <az-text-view
                    label="Tipo"
                    :text="movimentacao.tipo | azEnum(tipoMovimentacao)"/>
            </v-col>
            <v-col  md="4" sm="6" xs="12">
                <az-text-view
                    label="Órgão de Origem"
                    :text="movimentacao.orgaoOrigem.descricao"/>
            </v-col>
            <v-col  md="4" sm="6" xs="12">
                <az-text-view
                    label="Setor Origem"
                    :text="patrimonio.setor | textoSemValorSimples"/>
            </v-col>
            <v-col v-if="validarSeMovimentacaoFinalizada" md="4" sm="4" xs="4">
                <az-text-view
                    label="Finalizado Por"
                    :text="movimentacao.usuarioFinalizacao"
                />
            </v-col>
            <v-col md="4" sm="4" xs="4">
                <az-text-view
                    :label="getNomeCamposPersonalizados('motivoObs','MOVIMENTACAO')"
                    :text="movimentacao.motivo"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex'

    const {mapGetters} = createNamespacedHelpers('CamposPersonalizados')

    export default {
        name: 'MovimentacaoDetalheCamposBaixa',
        props: ['movimentacao', 'patrimonio'],
        computed: {
            ...mapGetters(['getNomeCamposPersonalizados']),
            validarSeMovimentacaoFinalizada() {
                return this.movimentacao.situacao === 'FINALIZADO'
            }
        }
    }
</script>
